import React from "react";
import { post } from "../fetchData";

const useFetchFaq = () => {
  const [data, setFaq] = React.useState<any>({});
  const [loading, setLoading] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    listFaq();
  }, []);

  const listFaq = () => {
    setLoading(true);
    setLoaded(false);
 post( {},"list_faq").then(
        (result) => {
          setLoading(false);
          console.log(result);
            setFaq(result?.status ? result : {});
        },
        (error) => {
          setFaq({});
        }
      )
      .finally(() => {
        setLoading(false);
        setLoaded(false);
      }); //fetch
  }; //doAjax

  return {data,loading,loaded};
};

export default useFetchFaq;
